import { Box } from "@mui/material";

import ProposalState from "../constants/ProposalState";
import { getStateData } from "../helper/gigStates";
import { theme } from "../mui-customs/Theme";
import Typography from "./Typography";

interface GigStateTagProps {
  gigStateValue: ProposalState;
  bidValue?: number;
}

const GigStateTag = ({ gigStateValue, bidValue }: GigStateTagProps) => {
  const { color, text } = getStateData(gigStateValue);
  return (
    <Box
      sx={{
        padding: 1,
        borderRadius: "0.5rem",
        backgroundColor: color,
        width: "fit-content",
      }}
    >
      <Typography variant="small5" sx={{ color: theme.brand1[50] }}>
        {`${text}${
          gigStateValue === ProposalState.OPEN_BID && bidValue
            ? `: $${bidValue}`
            : ""
        }`}
      </Typography>
    </Box>
  );
};

export default GigStateTag;
